import * as React from 'react';

type NewsHeadlineCardProps = {
  url: string;
  heading: string;
  label: string;
  contentType: string;
};

const NewsHeadlineCard: React.FC<NewsHeadlineCardProps> = ({
  url,
  heading,
  label,
  contentType,

}) => (
  <div className="news-headline-card featured-item">
    <a
      className="news-headline-card__link"
      href={url}
      target="_blank"
      rel="noreferrer"
    ></a>
    <p className="news-headline-card__headline">{heading}</p>
    <p className="news-headline-card__label">{contentType} | {label}</p>
  </div>
);

export default NewsHeadlineCard;
